import { baseBreathingPatternSchema, baseCoughSchema, baseCpapBipapSchema, baseLungAuscultationSchema, baseMechanicalVentilatorSchema, baseRespiratoryTreatmentsSchema, baseSmokingHistorySchema, baseTracheostomySchema, } from '../validations/shared/respiratory';
const smokingHistoryShape = baseSmokingHistorySchema.shape;
const breathingPatternShape = baseBreathingPatternSchema.shape;
const lungAuscultationShape = baseLungAuscultationSchema.shape;
const coughShape = baseCoughSchema.shape;
const cpapBipapShape = baseCpapBipapSchema.shape;
const mechanicalVentilatorShape = baseMechanicalVentilatorSchema.shape;
const tracheostomyShape = baseTracheostomySchema.shape;
const treatmentsShape = baseRespiratoryTreatmentsSchema.shape;
export const smokingHistoryFields = [
    { key: 'smokingStatus', field: smokingHistoryShape.smokingStatus },
    { key: 'packYears', field: smokingHistoryShape.packYears },
    { key: 'quitYear', field: smokingHistoryShape.quitYear },
    { key: 'vape', field: smokingHistoryShape.vape },
];
export const breathingPatternFields = [
    { key: 'shortness', field: breathingPatternShape.shortness },
    { key: 'mrcScale', field: breathingPatternShape.mrcScale },
    { key: 'breathingPattern', field: breathingPatternShape.breathingPattern },
    { key: 'accessoryMuscleUse', field: breathingPatternShape.accessoryMuscleUse },
    { key: 'pursedLipBreathing', field: breathingPatternShape.pursedLipBreathing },
];
export const lungLobeFields = [
    { key: 'upperRight', field: lungAuscultationShape.upperRight },
    { key: 'upperLeft', field: lungAuscultationShape.upperLeft },
    { key: 'midRight', field: lungAuscultationShape.midRight },
    { key: 'midLeft', field: lungAuscultationShape.midLeft },
    { key: 'lowerRight', field: lungAuscultationShape.lowerRight },
    { key: 'lowerLeft', field: lungAuscultationShape.lowerLeft },
];
export const lungDetailsFields = [
    { key: 'details', field: lungAuscultationShape.details, variant: 'tags' },
];
export const coughFields = [{ key: 'cough', field: coughShape.cough }];
export const coughDetailFields = [
    { key: 'color', field: coughShape.color },
    { key: 'amount', field: coughShape.amount },
];
export const papTherapyFields = [{ key: 'papTherapy', field: cpapBipapShape.papTherapy }];
export const cpapFields = [
    { key: 'cpapPressure', field: cpapBipapShape.cpapPressure },
    { key: 'cpapMaskType', field: cpapBipapShape.cpapMaskType },
    { key: 'cpapCompliance', field: cpapBipapShape.cpapCompliance },
    { key: 'cpapAdherence', field: cpapBipapShape.cpapAdherence },
];
export const bipapFields = [
    { key: 'bipapIpap', field: cpapBipapShape.bipapIpap },
    { key: 'bipapEpap', field: cpapBipapShape.bipapEpap },
    { key: 'bipapBackupRate', field: cpapBipapShape.bipapBackupRate },
    { key: 'bipapMaskType', field: cpapBipapShape.bipapMaskType },
    { key: 'bipapCompliance', field: cpapBipapShape.bipapCompliance },
    { key: 'bipapAdherence', field: cpapBipapShape.bipapAdherence },
];
export const ventilatorInUseFields = [
    { key: 'ventilatorInUse', field: mechanicalVentilatorShape.ventilatorInUse },
];
export const ventilatorDetailFields = [
    { key: 'ventMode', field: mechanicalVentilatorShape.ventMode },
    { key: 'tidalVolume', field: mechanicalVentilatorShape.tidalVolume },
    { key: 'fio2', field: mechanicalVentilatorShape.fio2 },
    { key: 'peep', field: mechanicalVentilatorShape.peep },
    { key: 'setRate', field: mechanicalVentilatorShape.setRate },
    { key: 'pressureSupport', field: mechanicalVentilatorShape.pressureSupport },
    { key: 'patientTriggeredBreaths', field: mechanicalVentilatorShape.patientTriggeredBreaths },
    { key: 'alarms', field: mechanicalVentilatorShape.alarms },
    { key: 'settingsMatchOrders', field: mechanicalVentilatorShape.settingsMatchOrders },
    { key: 'ventCircuit', field: mechanicalVentilatorShape.ventCircuit },
];
export const tracheostomyPresentFields = [
    { key: 'tracheostomyPresent', field: tracheostomyShape.tracheostomyPresent },
];
export const tracheostomyDetailFields = [
    { key: 'tubeType', field: tracheostomyShape.tubeType },
    { key: 'tubeSize', field: tracheostomyShape.tubeSize },
    { key: 'lastTubeChange', field: tracheostomyShape.lastTubeChange, formatDate: true },
    { key: 'stomaSiteAssessment', field: tracheostomyShape.stomaSiteAssessment },
    { key: 'secretionManagement', field: tracheostomyShape.secretionManagement },
    { key: 'innerCannula', field: tracheostomyShape.innerCannula },
    { key: 'suctioning', field: tracheostomyShape.suctioning },
    { key: 'trachCareBy', field: tracheostomyShape.trachCareBy },
];
export const nebulizerFields = [
    { key: 'nebulizerTreatment', field: treatmentsShape.nebulizerTreatment },
];
export const nebulizerNotesFields = [
    { key: 'nebulizerTreatmentNotes', field: treatmentsShape.nebulizerTreatmentNotes },
];
export const mdiFields = [{ key: 'mdiInhaler', field: treatmentsShape.mdiInhaler }];
export const mdiNotesFields = [
    { key: 'mdiInhalerNotes', field: treatmentsShape.mdiInhalerNotes },
];
export const incentiveChestPtFields = [
    { key: 'incentiveSpirometry', field: treatmentsShape.incentiveSpirometry },
    { key: 'chestPt', field: treatmentsShape.chestPt },
];
